<template lang="pug">
  .ds-page--applications
    list(
      :headers="headers"
      :list="list"
      :loading="loading"
      :pagination="pagination"
      :primaryPagination="primaryPagination"
      @loadMore="loadMore"
      @change:sorting="updateSorting"
      @needToUpdate="loadList({})"
    )
    portal(to="ds-pagination")
      pagination(:pagination="pagination" :loading="loading" @change="loadList({})")
</template>

<script>
import paginationMixin from '@/mixins/pagination.mixin'
import { DrivingSchoolService } from '../../core/drivingSchool-service'
import { DRIVING_SCHOOL_HEADERS_APPLICATIONS } from '../../core/drivingSchool-const'
import PaginationModel from '@/models/paginationModel'

export default {
  name: 'DrivingSchoolPageApplications',

  mixins: [paginationMixin],

  data: () => ({
    list: [],
    loading: false,
    pagination: {},
    primaryPagination: {},
    headers: DRIVING_SCHOOL_HEADERS_APPLICATIONS
  }),

  async mounted() {
    await this.setDefaultPagination()
    await this.loadList({})
  },

  methods: {
    async loadMore() {
      if (!this.pagination) return
      await this.onLoadMoreClick()
      await this.loadList({more: true})
    },

    async loadList({more = false}, query) {
      try {
        this.loading = true
        let {results, pagination} = await new DrivingSchoolService().list_applications({...this.$route.query, ...query})
        if (more) this.list.push(...results)
        else this.list = results
        await this.$nextTick()
        this.pagination = new PaginationModel(this.setPaginationParams(pagination))
        if (!more) this.setPrimaryPagination()
      } catch (error) {
        console.log(error)
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_CRM})
      } finally {
        this.loading = false
      }
    },

    async updateSorting(ordering) {
      await this.$router.replace({query: {...this.$route.query, ...this.getDefaultPagination(), ordering: ordering}})
      await this.loadList({})
    },

    setPrimaryPagination() {
      this.primaryPagination = { page: this.pagination.page, size: this.pagination.size }
    }
  },

  components: {
    list: () => import('./SchoolApplicationList.vue'),
    pagination: () => import('@/components/widget/PaginationWidget.vue'),
  }
}
</script>

<style lang="scss">
.ds-page--applications .jumbotron {
  border-top: none;
}
</style>
